/* eslint-disable max-len */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetUserProfileData, UpdateProfileData, UserProfileState } from '../Utils/TypeProfile';
import { defaultSidebarColorDetails } from '../../addCustomer/utils/helper';

const initialState: UserProfileState = {
  userProfile: {} as GetUserProfileData,
  isLoading: false,
  error: '',

  profileUpdateData: {},
  responseMessage: '',
  isSuccess: false,
  isImageSuccess: false,
  loading: false,

  userImage: '',
  sidebarStylesData: {} as {
    TextColor: string;
    BackgroundColor: string;
    SecondBackgroundColor: string;
    SelectionColor: string;
    IsDark: boolean;
  },
  mySidebarStyles: {
    textColor: defaultSidebarColorDetails.textColor,
    backgroundColor: defaultSidebarColorDetails.backgroundColor,
    secondBackgroundColor: defaultSidebarColorDetails.secondBackgroundColor,
    selectedBackgroundColor: defaultSidebarColorDetails.selectedBackgroundColor,
    imageSet: defaultSidebarColorDetails.imageSet,
  },
};

const getUserProfileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    getUserProfileStart(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    successGetUserProfile(state, action: PayloadAction<GetUserProfileData >) {
      return {
        ...state,
        isLoading: false,
        userProfile: action.payload,
      };
    },
    failureGetUserProfile(state, action: PayloadAction<string>) {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    },
    updateUserProfile(state, action: PayloadAction<UpdateProfileData>) {
      return {
        ...state,
        loading: true,
        profileUpdateData: action.payload,
      };
    },
    successUpdateProfile(state) {
      return {
        ...state,
        loading: false,
        isSuccess: true,
      };
    },
    failureUpdateProfile(state, action: PayloadAction<string>) {
      return {
        ...state,
        loading: false,
        isSuccess: false,
        responseMessage: action.payload,
      };
    },
    updateProfileImage(state, action) {
      return {
        ...state,
        isLoading: true,
        userImage: action.payload,
      };
    },
    updateImageSuccess(state, action: PayloadAction<string>) {
      return {
        ...state,
        isImageSuccess: true,
        isLoading: false,
        responseMessage: action.payload,
      };
    },
    updateImageFailure(state, action: PayloadAction<string>) {
      return {
        ...state,
        isImageSuccess: false,
        isLoading: false,
        responseMessage: action.payload,
      };
    },
    resetState(state) {
      return {
        ...state,
        isSuccess: false,
        isImageSuccess: false,
        responseMessage: '',
      };
    },
    getSidebarStyles(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    getSidebarStylesSuccess(state, action: PayloadAction<{ TextColor: string; BackgroundColor: string; SecondBackgroundColor: string; SelectionColor: string; IsDark: boolean }>) {
      return {
        ...state,
        isLoading: false,
        sidebarStylesData: action.payload,
      };
    },
    getSidebarStylesFailure(state, action: PayloadAction<string>) {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    },
    updateSidebarStyles(state, _action: PayloadAction<object>) {
      return {
        ...state,
        isLoading: true,
      };
    },
    updateSidebarStylesSuccess(state) {
      return {
        ...state,
        isLoading: false,
      };
    },
    updateSidebarStylesFailure(state, action: PayloadAction<string>) {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    },
    setMySidebarStyles(state, action: PayloadAction<{ textColor: string; backgroundColor: string; secondBackgroundColor: string; selectedBackgroundColor: string; imageSet: string }>) {
      return {
        ...state,
        mySidebarStyles: action.payload,
      };
    },
  },
});

export const {
  getUserProfileStart, successGetUserProfile, failureGetUserProfile, updateUserProfile, successUpdateProfile, failureUpdateProfile,
  updateProfileImage, updateImageSuccess, updateImageFailure, resetState, getSidebarStyles, getSidebarStylesSuccess,
  getSidebarStylesFailure, setMySidebarStyles, updateSidebarStyles, updateSidebarStylesSuccess, updateSidebarStylesFailure,
} = getUserProfileSlice.actions;
export const userProfileReducer = getUserProfileSlice.reducer;

export type GetUserProfileActions =
    | ReturnType<typeof getUserProfileStart>
    | ReturnType<typeof successGetUserProfile>
    | ReturnType<typeof failureGetUserProfile>
    | ReturnType<typeof updateUserProfile>
    | ReturnType<typeof successUpdateProfile>
    | ReturnType<typeof failureUpdateProfile>
    | ReturnType<typeof updateProfileImage>
    | ReturnType<typeof updateImageSuccess>
    | ReturnType<typeof resetState>
    | ReturnType<typeof updateImageFailure>
    | ReturnType<typeof getSidebarStyles>
    | ReturnType<typeof getSidebarStylesSuccess>
    | ReturnType<typeof getSidebarStylesFailure>
    | ReturnType<typeof setMySidebarStyles>
    | ReturnType<typeof updateSidebarStyles>
    | ReturnType<typeof updateSidebarStylesSuccess>
    | ReturnType<typeof updateSidebarStylesFailure>;
